var addDOMEventListener = require('add-dom-event-listener');

module.exports = addDOMEventListener['default'] || addDOMEventListener;
